var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowthCapital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9991 41.88C34.3993 41.88 41.2091 35.0702 41.2091 26.67C41.2091 18.2697 34.3993 11.46 25.9991 11.46C17.5988 11.46 10.7891 18.2697 10.7891 26.67C10.7891 35.0702 17.5988 41.88 25.9991 41.88Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9991 41.88C34.3993 41.88 41.2091 35.0702 41.2091 26.67C41.2091 18.2697 34.3993 11.46 25.9991 11.46C17.5988 11.46 10.7891 18.2697 10.7891 26.67C10.7891 35.0702 17.5988 41.88 25.9991 41.88Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1608 29.25C32.1408 28.98 32.0508 28.62 31.8908 28.16C31.7308 27.7 31.5108 27.31 31.2108 26.98C30.9108 26.65 30.4708 26.31 29.8908 25.96C29.3108 25.61 28.6008 25.32 27.7708 25.09L27.1008 24.92V20.95C27.4108 21.04 27.6908 21.22 27.9308 21.5C28.2808 21.91 28.4708 22.42 28.4808 23.01H31.6308C31.5408 21.56 31.0508 20.45 30.1408 19.68C29.3408 18.99 28.3208 18.55 27.0908 18.35V16.58H26.6308H25.3208H24.9008V18.33C23.6408 18.49 22.5608 18.93 21.6708 19.66C20.6808 20.47 20.1808 21.6 20.1808 23.03C20.1808 23.74 20.3008 24.35 20.5308 24.87C20.7708 25.39 21.1208 25.81 21.5808 26.13C22.0508 26.46 22.5008 26.71 22.9608 26.91C23.4108 27.1 23.9608 27.28 24.6108 27.44C24.7108 27.47 24.8008 27.49 24.8908 27.51V32.16C24.3808 31.99 23.9408 31.71 23.5908 31.31C23.1508 30.8 22.9308 30.15 22.9508 29.35H19.8008C20.1108 32.63 21.8108 34.45 24.8908 34.83V36.76H25.3208H26.6308H27.0908V34.83C27.7508 34.75 28.3608 34.61 28.9108 34.4C29.5808 34.14 30.1208 33.84 30.5108 33.49C30.9008 33.14 31.2308 32.76 31.5008 32.34C31.7708 31.92 31.9508 31.53 32.0408 31.19C32.1408 30.84 32.1808 30.53 32.1808 30.25C32.1908 29.85 32.1808 29.51 32.1608 29.25ZM23.7908 23.86C23.4908 23.59 23.3408 23.22 23.3408 22.73C23.3408 22.14 23.5408 21.68 23.9308 21.37C24.2108 21.14 24.5408 21 24.9008 20.93V24.39C24.4008 24.24 24.0308 24.06 23.7908 23.86ZM28.3208 31.64C27.9608 31.92 27.5508 32.11 27.1008 32.21V28.16C27.7508 28.36 28.2308 28.58 28.5208 28.82C28.8708 29.12 29.0408 29.54 29.0408 30.11C29.0408 30.76 28.8008 31.27 28.3208 31.64Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1699 43.41V11.41",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3398 14.56L46.1698 9.72998L50.9998 14.56",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83008 43.41V11.41",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.66 14.56L5.83 9.72998L1 14.56",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthCapital);
export default __webpack_public_path__ + "static/media/GrowthCapital.ed70a46edc44e7f06cd04f911d34d2d1.svg";
export { ForwardRef as ReactComponent };